import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logotype',
  templateUrl: './logotype.component.html',
  styleUrls: ['./logotype.component.css']
})
export class LogotypeComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
